import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  AppState,
  CampaignUpdateRequest,
  CancelTrial,
  CreateCampaign,
  ReserveTrial,
  SendRedemptionLinkPayload,
} from '@ra-state';
import {
  cancelReservation,
  createCampaign,
  endCampaign,
  getCampaignDetails,
  getTrialBundles,
  pauseCampaign,
  reserveTrial,
  resetCampaignDetails,
  resumeCampaign,
  sendRedemptionLinks,
  updateCampaign,
} from './trials.action';
import { selectCampaignDetails, selectRefreshTrialGrid, selectTrialBundles } from './trials.selectors';

@Injectable({
  providedIn: 'root',
})
export class TrialsFacade {
  private readonly store$ = inject<Store<AppState>>(Store);

  campaignDetails$ = this.store$.select(selectCampaignDetails);
  trialBundles$ = this.store$.select(selectTrialBundles);
  refreshTrialGrid$ = this.store$.select(selectRefreshTrialGrid);

  reserveTrial(customerInfo: ReserveTrial): void {
    this.store$.dispatch(reserveTrial({ payload: customerInfo }));
  }

  cancelReservation(reservationData: CancelTrial[]): void {
    this.store$.dispatch(cancelReservation({ trialReservations: reservationData }));
  }

  createCampaign(campaignPayload: CreateCampaign): void {
    this.store$.dispatch(createCampaign({ payload: campaignPayload }));
  }

  getCampaignDetails(campaignId: string): void {
    this.store$.dispatch(getCampaignDetails({ payload: campaignId }));
  }

  pauseCampaign(campaignId: string): void {
    this.store$.dispatch(pauseCampaign({ campaignId: campaignId }));
  }

  resumeCampaign(campaignId: string): void {
    this.store$.dispatch(resumeCampaign({ campaignId: campaignId }));
  }

  endCampaign(campaignId: string): void {
    this.store$.dispatch(endCampaign({ campaignId: campaignId }));
  }

  getTrialBundles(): void {
    this.store$.dispatch(getTrialBundles());
  }

  updateCampaign(payload: CampaignUpdateRequest): void {
    this.store$.dispatch(updateCampaign({ payload }));
  }

  sendRedemptionLinks(payload: SendRedemptionLinkPayload): void {
    this.store$.dispatch(sendRedemptionLinks({ payload }));
  }

  resetCampaignDetails(): void {
    this.store$.dispatch(resetCampaignDetails());
  }
}
